<template>
    <div>
        <draw-from-sets v-for="lottery in sets" v-bind:lottery="lottery" v-bind:key="lottery.name"></draw-from-sets>
        <sequence v-for="lottery in sequences" v-bind:lottery="lottery" v-bind:key="lottery.name"></sequence>
    </div>
</template>

<script>
    import DrawFromSets from '@/components/DrawFromSets';
    import Sequence from '@/components/Sequence';

    export default {
        components: {
            DrawFromSets,
            Sequence
        },
        data () {
            return {
                sets: [
                    {
                        name: 'EuroJackpot',
                        sets: [
                            {
                                label: 'Zahlen',
                                draw: 5,
                                range: [1, 50]
                            },
                            {
                                label: 'Eurozahlen',
                                draw: 2,
                                range: [1, 10]
                            }
                        ]
                    }, {
                        name: 'Lotto 6 aus 49',
                        sets: [
                            {
                                label: 'Zahlen',
                                draw: 6,
                                range: [1, 49]
                            },
                            {
                                label: 'Superzahl',
                                draw: 1,
                                range: [0, 9]
                            }
                        ]
                    }, {
                        name: 'EuroMillions',
                        sets: [
                            {
                                label: 'Zahlen',
                                draw: 5,
                                range: [1, 50]
                            },
                            {
                                label: 'Sterne',
                                draw: 2,
                                range: [1, 12]
                            }
                        ]
                    }, {
                        name: 'Cash4Life',
                        sets: [
                            {
                                label: 'Zahlen',
                                draw: 5,
                                range: [1, 60]
                            },
                            {
                                label: 'Zusatzzahlen',
                                draw: 1,
                                range: [1, 4]
                            }
                        ]
                    }
                ],
                sequences: [
                    {
                        name: 'World Millions',
                        length: 8
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Start.vue?fcd18a50